import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const DocumentTitle = () => {
    const location = useLocation();
    const { t, i18n } = useTranslation('common');

    useEffect(() => {
        let pageKey = 'default';

        // Déterminer la clé de traduction en fonction de la route
        if (location.pathname === '/appointment') {
            pageKey = 'appointment';
        } else if (location.pathname === '/events' || location.pathname === '/' || location.pathname === '/home') {
            pageKey = 'events';
        }

        // Obtenir la traduction du titre de la page
        const pageTitle = t(`pageTitles.${pageKey}`);

        // Mettre à jour le titre de l'onglet avec "Subzero Wolf Cove | [Titre de la page]"
        document.title = `Subzero Wolf Cove | ${pageTitle}`;
    }, [location.pathname, t, i18n.language]);

    return null;
};

